import {
  fetchOrgUsers,
  createOrgUser,
  updateOrgUser,
  deleteOrgUser,
  resetOrgUserPassword,
} from '@/api/usersApi'

export default {
  methods: {
    listOrgUsers(input = {}) {
      return fetchOrgUsers(input)
    },
    createOrgUser(input) {
      return createOrgUser(input)
    },
    updateOrgUser(input) {
      return updateOrgUser(input)
    },
    deleteOrgUser(input) {
      return deleteOrgUser(input)
    },
    resetOrgUserPassword(input) {
      return resetOrgUserPassword(input)
    },
  },
}
